// Landing page — tiny enhancement layer. Everything works without JS;
// this just adds (a) subtle fade-in on scroll for section blocks, and
// (b) a hairline border on the sticky header once the user scrolls.

import './styles.css';

/* ── Header border on scroll ─────────────────────────────── */
const header = document.querySelector<HTMLElement>('.site-header');
if (header) {
  const updateHeader = (): void => {
    header.classList.toggle('scrolled', window.scrollY > 4);
  };
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}

/* ── Reveal-on-scroll for top-level section content ──────── */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reduceMotion && 'IntersectionObserver' in window) {
  const targets = document.querySelectorAll<HTMLElement>(
    '.section-head, .card, .arch-diagram, .arch-col, .code-block, .feature-list > li, .cta-inner, .hero-stats',
  );

  targets.forEach((el, i) => {
    el.classList.add('reveal');
    // Light stagger so siblings don't all pop at once.
    el.style.transitionDelay = `${Math.min(i % 6, 5) * 40}ms`;
  });

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
  );

  targets.forEach((el) => io.observe(el));
}
